import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ─── Auth: misma lógica exacta del original ───
  const token = window.sessionStorage.getItem('localToken');
  const username = window.sessionStorage.getItem('username');
  let roleId = null;
  let roleName = 'Superadministrador';
  try {
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      roleId = payload.roleId;
      if (roleId === 1) roleName = 'Superadministrador';
      else if (roleId === 2) roleName = 'Administrador';
      else roleName = 'Operador';
    }
  } catch (e) {
    roleId = null;
  }

  // ─── Navegación: mismas rutas exactas ───
  const navItems = [
    { path: '/home', label: 'Inicio', match: '/home' },
    { path: '/clients', label: 'Clientes', match: '/clients' },
    { path: '/credits', label: 'Créditos', match: '/credits' },
    { path: '/documents', label: 'Informes', match: '/documents' },
    { path: '/uvr', label: 'Valores UVR', match: '/uvr' },
  ];

  const isActive = (item) => {
    return location.pathname.startsWith(item.match);
  };

  // ─── Logout: misma lógica exacta del App.jsx original ───
  const logOut = () => {
    sessionStorage.clear();
    sessionStorage.setItem("loggedIn", false);
    window.location.href = '/login';
  };

  return (
    <header style={{
      height: '72px',
      background: 'rgba(255, 255, 255, 0.94)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      borderBottom: '1px solid #EAECF0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 1.5rem',
      gap: '1rem',
      zIndex: 1000,
      position: 'relative'
    }}>
      {/* Brand Identity — Logo Original Mobilia + Software Inmobiliario */}
      <div 
        onClick={() => navigate('/home')}
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '0.85rem',
          cursor: 'pointer',
          flexShrink: 0,
          userSelect: 'none',
          transition: 'opacity 0.2s ease'
        }}
        title="Inmobiliaria Mobilia — Inicio"
        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.88'}
        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
      >
        <img 
          src={require("../res/logo-mobilia.jpg")} 
          alt="Inmobiliaria Mobilia" 
          style={{ 
            height: '40px', 
            objectFit: 'contain',
            display: 'block'
          }} 
        />

        <div style={{
          height: '28px',
          width: '1px',
          background: '#EAECF0'
        }} />

        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center',
          whiteSpace: 'nowrap'
        }}>
          <span style={{ 
            fontSize: '0.86rem', 
            color: '#101828', 
            fontWeight: 700,
            letterSpacing: '-0.02em',
            whiteSpace: 'nowrap',
            lineHeight: 1.2
          }}>
            Software Inmobiliario
          </span>
          <span style={{ 
            fontSize: '0.70rem', 
            color: '#667085', 
            fontWeight: 500,
            whiteSpace: 'nowrap',
            lineHeight: 1.2,
            marginTop: '2px'
          }}>
            Administración de Cartera Hipotecaria
          </span>
        </div>
      </div>

      {/* Center Navigation Pills */}
      <nav style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        background: '#F2F4F7',
        padding: '3px',
        borderRadius: '9999px',
        flexShrink: 0
      }}>
        {navItems.map((item) => {
          const active = isActive(item);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              style={{
                background: active ? '#111111' : 'transparent',
                color: active ? '#ffffff' : '#667085',
                border: 'none',
                padding: '0.38rem 0.90rem',
                borderRadius: '9999px',
                fontSize: '0.80rem',
                fontWeight: active ? 600 : 500,
                cursor: 'pointer',
                transition: 'all 0.18s ease',
                boxShadow: active ? '0 2px 8px rgba(17, 17, 17, 0.12)' : 'none',
                fontFamily: 'inherit',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                if (!active) {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.7)';
                  e.currentTarget.style.color = '#111111';
                }
              }}
              onMouseLeave={(e) => {
                if (!active) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#667085';
                }
              }}
            >
              {item.label}
            </button>
          );
        })}
      </nav>

      {/* User Actions — UVR, User Info, Perfil & Salir */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '0.55rem', 
        flexShrink: 0 
      }}>
        {/* UVR Capsule */}
        <div 
          onClick={() => navigate('/uvr')}
          className="liquid-glass"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.35rem',
            padding: '0.36rem 0.75rem',
            borderRadius: '9999px',
            fontSize: '0.78rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.18s ease',
            color: '#171717',
            whiteSpace: 'nowrap',
            userSelect: 'none',
            flexShrink: 0
          }}
          title="Ver histórico oficial de tasas UVR"
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = 'rgba(215, 25, 32, 0.3)';
            e.currentTarget.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.85)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <TrendingUpIcon style={{ fontSize: '0.90rem', color: '#D71920' }} />
          <span>UVR</span>
        </div>

        {/* User Pill Capsule — Bien estructurado, sin saltos de línea */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.45rem',
          padding: '0.36rem 0.85rem',
          borderRadius: '9999px',
          background: '#FFFFFF',
          border: '1px solid #EAECF0',
          fontSize: '0.78rem',
          boxShadow: '0 1px 3px rgba(16, 24, 40, 0.04)',
          whiteSpace: 'nowrap',
          flexShrink: 0,
          userSelect: 'none'
        }}>
          {/* Indicador de estado verde fijo */}
          <span style={{
            width: '7px',
            height: '7px',
            borderRadius: '50%',
            background: '#12B76A',
            boxShadow: '0 0 6px rgba(18, 183, 106, 0.4)',
            flexShrink: 0,
            display: 'inline-block'
          }} />

          {/* Rol */}
          <span style={{ 
            color: '#667085', 
            fontWeight: 500,
            whiteSpace: 'nowrap'
          }}>
            {roleName}
          </span>

          {/* Separador vertical sutil (reemplaza al punto que se caía a la segunda línea) */}
          <span style={{
            width: '1px',
            height: '11px',
            background: '#D0D5DD',
            flexShrink: 0,
            margin: '0 0.1rem'
          }} />

          {/* Username */}
          <strong style={{ 
            color: '#101828', 
            fontWeight: 700,
            whiteSpace: 'nowrap'
          }}>
            {username || 'admin'}
          </strong>
        </div>

        {/* Profile Button */}
        <button
          onClick={() => navigate('/login')}
          title="Ver perfil de usuario y seguridad"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.35rem',
            background: '#FFFFFF',
            border: '1px solid #EAECF0',
            color: '#344054',
            padding: '0.38rem 0.80rem',
            borderRadius: '9999px',
            fontSize: '0.78rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.18s ease',
            boxShadow: '0 1px 3px rgba(16, 24, 40, 0.04)',
            fontFamily: 'inherit',
            flexShrink: 0,
            whiteSpace: 'nowrap',
            userSelect: 'none'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#F9FAFB';
            e.currentTarget.style.borderColor = '#CBD5E1';
            e.currentTarget.style.color = '#111111';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#FFFFFF';
            e.currentTarget.style.borderColor = '#EAECF0';
            e.currentTarget.style.color = '#344054';
          }}
        >
          <AccountCircleIcon style={{ fontSize: '0.95rem', color: '#667085' }} />
          <span>Perfil</span>
        </button>

        {/* Logout Button */}
        <button
          onClick={logOut}
          title="Cerrar sesión"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.30rem',
            background: '#FFFFFF',
            border: '1px solid #EAECF0',
            color: '#667085',
            padding: '0.38rem 0.80rem',
            borderRadius: '9999px',
            fontSize: '0.78rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.18s ease',
            fontFamily: 'inherit',
            flexShrink: 0,
            whiteSpace: 'nowrap',
            userSelect: 'none'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#FEF3F2';
            e.currentTarget.style.borderColor = '#FECDCA';
            e.currentTarget.style.color = '#D71920';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#FFFFFF';
            e.currentTarget.style.borderColor = '#EAECF0';
            e.currentTarget.style.color = '#667085';
          }}
        >
          <LogoutIcon style={{ fontSize: '0.88rem' }} />
          <span>Salir</span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;
